import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const VideoProjector = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M6 5.646a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 5.334a2.333 2.333 0 1 0 0-4.667 2.333 2.333 0 0 0 0 4.667Z" />
      <path d="M14 14.313H2a1.669 1.669 0 0 1-1.666-1.666v-4A1.669 1.669 0 0 1 2.001 6.98h1.693a.333.333 0 0 1 0 .667H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H8.306a.333.333 0 1 1 0-.667H14a1.669 1.669 0 0 1 1.667 1.667v4A1.668 1.668 0 0 1 14 14.313Z" />
      <path d="M6 7.646a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM6 8.98a.333.333 0 1 0 0-.667.333.333 0 0 0 0 .667ZM13.001 9.981h-2a.333.333 0 1 1 0-.667h2a.333.333 0 0 1 0 .667ZM13.001 11.98h-2a.333.333 0 1 1 0-.668h2a.334.334 0 0 1 0 .667ZM3.333 15.313A.333.333 0 0 1 3 14.98v-1a.333.333 0 1 1 .667 0v1a.333.333 0 0 1-.334.333ZM12.667 15.313a.333.333 0 0 1-.333-.333v-1a.333.333 0 1 1 .667 0v1a.334.334 0 0 1-.334.333ZM6.001 4.314a.333.333 0 0 1-.333-.334V2.314a.333.333 0 0 1 .667 0V3.98A.333.333 0 0 1 6 4.314ZM9.3 5.681a.333.333 0 0 1-.236-.569l1.179-1.178a.333.333 0 0 1 .471.47l-1.178 1.18a.333.333 0 0 1-.236.097ZM2.701 5.681a.333.333 0 0 1-.235-.098L1.287 4.405a.333.333 0 0 1 .471-.471l1.179 1.178a.333.333 0 0 1-.236.57Z" />
    </svg>
  );
};

VideoProjector.category = 'product-category';

VideoProjector.displayName = 'VideoProjector';
